import {
  Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter, ViewChild
} from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Subscription } from 'rxjs';
import { EmailValidator } from '../../shared/helpers/email-validator';
import { JobService } from '../job-service/job.service';
import { ProfileModel } from '../job-service/models/profile-model';

@Component({
  selector: 'app-save-and-finish-later',
  templateUrl: './save-and-finish-later.component.html',
  styleUrls: ['./save-and-finish-later.component.scss']
})
export class SaveAndFinishLaterComponent implements OnInit, OnChanges, OnDestroy {
  subscriptions = new Subscription();
  confirmEmailAddress = '';
  emailRegex: string;
  saving = false;

  @Input() emailAddress = '';
  @Input() jobId: number;
  @Input() open = false;
  @Output() saved = new EventEmitter<string>();
  @Output() closed = new EventEmitter<boolean>();

  @ViewChild('saveAndFinishModal', { static: true })
  saveAndFinishModal: ModalDirective;

  constructor(private service: JobService) { }

  ngOnInit(): void {
    const emailValidator = new EmailValidator();
    this.emailRegex = emailValidator.emailRegex;

    this.subscriptions.add(this.saveAndFinishModal.closed.subscribe(() => {
      this.close();
    }));
  }

  ngOnChanges() {
    if (this.open) {
      if (this.emailAddress === '' && this.jobId > 0) {
        this.subscriptions.add(this.service.getProfile(this.jobId, +localStorage.getItem('applicationId'))
          .subscribe((data: ProfileModel) => {
            this.emailAddress = data.profile.emailAddress;
            this.saveAndFinishModal.show();
          }));
      } else {
        this.saveAndFinishModal.show();
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  saveAndFinishLater() {
    this.saving = true;
    this.saved.emit(this.emailAddress);
    this.close();
  }

  close() {
    this.saveAndFinishModal.hide();
    this.closed.emit(true);
    this.open = false;
  }

}
